import React, { useEffect } from 'react';
import {
    Container,
    Box,
    Card,
    Button,
    CardContent,
    Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
    IconWrapper,
    IconCircle,
    Title,
    Paragraph,
    ActionsWrapper,
} from '../../pages/auth/styled';
import LockClockIcon from '@mui/icons-material/LockClock';
import { MasterMessage } from '../../../masters/masterMessages';
import { SIGNIN } from '../../../routes/paths';
import { Copyright } from '../copyright/copyright';
import { types } from '../../../redux/types';
import { useDispatch } from 'react-redux';
import { useAuthContext } from '../../../contexts/authContext';

const ExpirationToken = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const { title, subTitle, messsage } = MasterMessage.auth.expirationToken;

    useEffect(() => {
        dispatch({
            type: types.logoutLogin,
            payload: '',
        });
        logout();
    }, []);

    return (
        <>
            <Box id="Sesión Expiró">
                <Container maxWidth="md" style={{ marginTop: 20 }}>
                    <Box mt={8}>
                        <Card>
                            <CardContent>
                                <IconWrapper>
                                    <IconCircle>
                                        <LockClockIcon
                                            style={{
                                                fontSize: '6rem',
                                                color: 'white',
                                                marginLeft: '1rem',
                                            }}
                                        />
                                    </IconCircle>
                                </IconWrapper>
                                <Title variant="h4">{title}</Title>
                                <Paragraph>{subTitle}</Paragraph>
                                <Typography
                                    align="center"
                                    variant="subtitle2"
                                    color="textSecondary"
                                >
                                    {messsage}
                                </Typography>
                                <ActionsWrapper>
                                    <Button
                                        variant="contained"
                                        onClick={() => navigate(SIGNIN)}
                                    >
                                        <Typography
                                            component="div"
                                            sx={{
                                                flexGrow: 1,
                                                fontSize: {
                                                    lg: 14,
                                                    md: 14,
                                                    xs: 10,
                                                },
                                            }}
                                        >
                                            On Time
                                        </Typography>
                                    </Button>
                                </ActionsWrapper>
                            </CardContent>
                        </Card>
                    </Box>
                </Container>
            </Box>
            <Copyright sx={{ position: 'relative', mt: 3 }} />
        </>
    );
};

export default ExpirationToken;
